// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"2d8cbbf2","256":"39becb3c"}[chunkId] + ".chunk.css";
};